import React from 'react';
import NodeActions from './NodeActions';
import NodeStatusBadge from './NodeStatusBadge';
import { nodeTheme } from './nodeTheme';

export default function NodeHeader({ type, data, Icon, categoryLabel, compact = false }) {
  const theme = nodeTheme[type] || nodeTheme.message;
  return <header className="mb-3 flex min-w-0 items-center gap-2.5">
    <span aria-hidden="true" className={`grid shrink-0 place-items-center rounded-xl ${compact ? 'h-9 w-9' : 'h-10 w-10'} ${theme.iconBox}`}><Icon sx={{ fontSize: compact ? 18 : 20 }} /></span>
    <div className="min-w-0 flex-1">
      <div className={`truncate text-[10px] font-bold uppercase tracking-[0.12em] ${theme.headerCategory}`} title={categoryLabel}>{categoryLabel}</div>
      <div className={`truncate font-semibold tracking-tight text-slate-900 dark:text-slate-100 ${compact ? 'text-sm' : 'text-[15px]'}`} title={data?.title || 'Untitled Node'}>{data?.title || 'Untitled Node'}</div>
    </div>
    <NodeStatusBadge data={data} />
    <NodeActions type={type} data={data} />
  </header>;
}
